'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _dom = require('../common/dom.js');

var _dom2 = _interopRequireDefault(_dom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var init = exports.init = function init() {
  if ($(_dom2.default.imdbDetails).length > 0) {
    var imdbID = $(_dom2.default.imdbDetails).attr('data-imdb-id');
    imdbDetails(imdbID);
  }
};

var imdbDetails = function imdbDetails(id) {
  $.get('https://www.omdbapi.com/?i=tt' + id + '&apikey=60d69ab4').then(function (data) {
    var description = data['Plot'];
    var director = data['Director'];
    var writers = data['Writer'];
    var actors = data['Actors'];
    var year = data['Year'];

    $(_dom2.default.imdbDescription).text(description);
    $(_dom2.default.imdbDirector).text(director);
    $(_dom2.default.imdbWriters).text(writers);
    $(_dom2.default.imdbActors).text(actors);
    $(_dom2.default.imdbYear).text(year);
  });
};